module.exports = __webpack_public_path__ + "static/media/broadcast.b86d6ff7.svg";